"use client";

const FIRST_LANDING_PAGE_KEY = "first_landing_page";

export const getFirstLandingPage = (): string => {
  if (typeof window === "undefined") return "";
  return window.sessionStorage.getItem(FIRST_LANDING_PAGE_KEY) || "";
};

export const ensureFirstLandingPage = (fallbackPath?: string): string => {
  if (typeof window === "undefined") return "";

  const existing = getFirstLandingPage();
  if (existing) return existing;

  const currentPath = fallbackPath || window.location.pathname || "/";
  window.sessionStorage.setItem(FIRST_LANDING_PAGE_KEY, currentPath);
  return currentPath;
};
